import { render } from "./AddClientDialog.vue?vue&type=template&id=3ae44400&scoped=true"
import script from "./AddClientDialog.vue?vue&type=script&lang=js"
export * from "./AddClientDialog.vue?vue&type=script&lang=js"

import "./AddClientDialog.vue?vue&type=style&index=0&id=3ae44400&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae44400"]])

export default __exports__